import React from 'react';
import { Container } from 'semantic-ui-react';
import LinkTiles from './LinkTiles';
import LinkList from './LinkList';
import { toSnakeCase } from '../helpers/common';

const RelevantTools = (props) => {
  const { module } = props;
  const { anchorTagLinkText, links, linkTiles, backgroundColour, heading } = module;

  const backgroundColourClassName = backgroundColour ? `related-news--${backgroundColour}` : '';

  const validLinks = links
    ? links.filter((linkItem) => {
        return linkItem.link && linkItem.link.url;
      })
    : [];

  return (
    <section
      className={`related-news ${backgroundColourClassName} related-tools__section`}
      id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}
    >
      <Container>
        <div className="grid-wrapper">
          <div className="relevant-tools__grid-container">
            <div className="relevant-tools__heading">{heading ? heading : 'Relevant tools, information and articles'}</div>
            <div className="relevant-tools__content">
              {linkTiles && (
                <div className="relevant-tools__tile">
                  <LinkTiles
                    link_tile_ids={linkTiles.map((linkTile) => {
                      return linkTile.databaseId;
                    })}
                  />
                </div>
              )}
              {validLinks && validLinks.length ? (
                <div className="relevant-tools__links">
                  <LinkList
                    links={validLinks.map((linkItem) => {
                      return {
                        link: linkItem.link.url,
                        title: linkItem.link.title,
                        target: linkItem.link.target,
                      };
                    })}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default RelevantTools;
